import { z } from 'zod';
import { FlowSubflowCloningStrategyByFlowKindSchema } from './subflowCloningStrategy.js';
import { FlowKind } from '../flow/enums.js';
import { FlowPricingMode } from '../flow/pricingMode.js';
import { FlowTagInputsSchema } from '../flow/tags.js';
/** What a clone does when the requested name is already taken in the target organization. */
export const FlowDefinitionDuplicateNameStrategySchema = z.enum(['ThrowError', 'AppendSuffix']);
/**
 * Body `POST /flow-definitions/{id}/clone-as-new-flow` accepts.
 *
 * The target organization is taken from `values.agentId`, then `values.organizationId`, then the
 * source definition, so a clone into the source's own organization can omit both.
 */
export const CloneFlowDefinitionAsNewFlowBodySchema = z.strictObject({
    values: z.object({
        name: z.string().describe('Name of the flow to create.'),
        description: z.string().optional(),
        documentationMarkdown: z.string().nullish(),
        agentId: z.uuid().describe('Agent to create the clone under.').nullish(),
        organizationId: z.uuid().describe('Organization to create the clone in.').optional(),
        tags: FlowTagInputsSchema.nullish(),
        pricingMode: z.enum(FlowPricingMode).optional(),
    }),
    targetFlowKind: z.enum(FlowKind).describe('Kind of flow the clone becomes.'),
    duplicateNameStrategy: FlowDefinitionDuplicateNameStrategySchema.optional().default('AppendSuffix'),
    subflowCloningStrategyByFlowKind: FlowSubflowCloningStrategyByFlowKindSchema.describe('How subflows of each kind are treated: cloned too, or referenced by id.').optional(),
});
//# sourceMappingURL=cloneRequests.js.map